// @flow

import {
  type EventPayload,
  MESSAGE_TYPE_ADD_TO_CART,
  MESSAGE_TYPE_PRODUCT_BUTTON,
  MESSAGE_TYPE_PRODUCTS,
  MESSAGE_TYPE_URL_BUTTON,
  MESSAGE_TYPE_USER_ATTRIBUTE_SET
} from '../../../common/iframeMessageTypes'

export type PayloadExtraProperties = {
  productId?: string,
  productIds?: string,
  url?: string
}

export function getPayloadExtraProperties (payload: EventPayload): PayloadExtraProperties {
  const values = {
    [MESSAGE_TYPE_URL_BUTTON]: () => ({ url: payload.url }),
    [MESSAGE_TYPE_PRODUCT_BUTTON]: () => ({ productId: payload.productId }),
    [MESSAGE_TYPE_ADD_TO_CART]: () => ({ productId: payload.productId ?? payload.productIds }),
    [MESSAGE_TYPE_PRODUCTS]: () => ({ productIds: payload.productIds }),
    [MESSAGE_TYPE_USER_ATTRIBUTE_SET]: () => ({ attribute: payload.attribute })
  }

  if (!values[payload.event]) return {}
  return values[payload.event]()
}
